import { render, staticRenderFns } from "./Accent.vue?vue&type=template&id=24b8323e&scoped=true&"
import script from "./Accent.vue?vue&type=script&lang=js&"
export * from "./Accent.vue?vue&type=script&lang=js&"
import style0 from "./Accent.vue?vue&type=style&index=0&id=24b8323e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8323e",
  null
  
)

export default component.exports